import React, { Component } from 'react';

export default class Resume extends Component {
  render() {
    return (
      <div>
        <h1>REsume</h1>
      </div>
    );
  }
}
